import {
  parseAsBoolean,
  parseAsString,
  useQueryStates,
  type UseQueryStatesKeysMap,
  createParser,
  createSerializer,
} from 'nuqs';

const params = {
  /** Show form (when outside of form page) */
  form: parseAsBoolean,
  /** Overwrite quote */
  requote: parseAsBoolean,
  /** First time requoting a quotation */
  firstRequote: parseAsBoolean,
  /** Allow Request Offer */
  aro: parseAsBoolean,
  /** Redis key for offers */
  uuid: parseAsString,
  book: parseAsBoolean,
  /** Reset form data */
  reset: parseAsBoolean,
  /** Selected Item. A quote in this case */
  si: createParser({
    parse(queryValue) {
      const parsed = /Q(\d+)/.exec(queryValue);
      const id = parsed?.at(1);
      if (!id) return null;
      return Number(id);
    },
    serialize(value) {
      return `Q${value}`;
    },
  }),
  /** Switch user */
  su: parseAsBoolean,
} satisfies UseQueryStatesKeysMap;

export default function useFormParams() {
  return useQueryStates(params);
}

export const serializeFormParams = createSerializer(params);
